import bindAllOfThis from "src/utils/BindThisHelper";
import { start } from 'repl';

export class PhaserColorWheel extends Phaser.GameObjects.Container {
    protected pickerImage: Phaser.GameObjects.Image;
    protected background: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number) {
        super(scene, x, y);
        bindAllOfThis(this, PhaserColorWheel.prototype);

        this.initialize(width, height);
        this.registerEvents();
    }

    static preload(scene: Phaser.Scene) {
        // https://cdn.jsdelivr.net/gh/samme/phaser-examples-assets@1.0.0/pics/color-wheel.png
        scene.load.image("colorwheel-background", require("/src/assets/online-assets/sprites/color-wheel.png"));

        // Construct a circle and make it a texture
        var tempGraphic = scene.add.graphics();
        tempGraphic.setDepth(0);
        tempGraphic.lineStyle(1, 0x000000);
        tempGraphic.fillStyle(0xbbbbbb);
        tempGraphic.fillEllipse(8, 8, 16, 16);
        tempGraphic.generateTexture("colorwheel-button-graphic", 16, 16);
        tempGraphic.clear();
        tempGraphic.destroy();
    }

    initialize(width: number, height: number): void {
        // Set size to size of background image
        this.setSize(500, 500);

        // Construct Objects
        this.constructObjects();

        // Only after we have set size can we change our scale to fit what was passed in
        this.setDisplaySize(width, height);

        // Add items to self and self to scene
        this.add(this.background);
        this.add(this.pickerImage);
        this.scene.add.existing(this);
    }

    constructObjects() {
        this.background = this.scene.add.image(0, 0, "colorwheel-background");
        this.background.setSize(this.width, this.height);
        this.background.setDepth(0);
        this.background.setOrigin(0);

        this.pickerImage = this.scene.add.image(this.background.getCenter().x + 132, this.background.getCenter().y + 160, "colorwheel-button-graphic");
        this.pickerImage.setDepth(1);

        var ellipse = new Phaser.Geom.Ellipse(this.background.frame.realWidth / 2, this.background.frame.realHeight / 2, this.background.frame.realWidth, this.background.frame.realHeight);
        this.background.setInteractive({ shape: ellipse, callback: Phaser.Geom.Ellipse.Contains, cursor: "crosshair" });
    }

    registerEvents(): void {
        this.background.on("pointerdown", (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            this.pickerImage.setPosition(x, y);
            let color = this.scene.textures.getPixel(x, y, "colorwheel-background", null);

            this.emit("colorChange", color);
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/shared/ColorWheel.ts